import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./Pages/Auth/Auth.css";

import "bootstrap/dist/css/bootstrap.min.css";

import { BrowserRouter as Router } from "react-router-dom";
import MenuContext from "./context/MenuContext";
import WindowContext from "./context/WindowContext";
import { CountsProvider } from "./context/CountsContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WindowContext>
      <MenuContext>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <CountsProvider>
            <App />
          </CountsProvider>
        </Router>
      </MenuContext>
    </WindowContext>
  </React.StrictMode>
);
